<template>
  <v-card>
    <v-form @submit.prevent="submitEditTripRateForm()" ref="editTripRateForm">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 class="vertical-center-container mb-3">
            <v-icon
              large
              class="mr-2"
              :color="$store.state.global.pages.rate.color"
            >{{$store.state.global.pages.rate.icon}}</v-icon>
            <span class="headline">Rate - {{editedRate.id}}</span>
          </v-flex>
          <flex-sub-header>Master Files</flex-sub-header>
          <v-flex xs12 class>
            <div>
              <row-info-display label="Site" :value="!!siteObj ? siteObj.name : '-'"></row-info-display>
              <div class="grey lighten-2 mb-2" style="height: 1px; width:100%;"></div>

              <row-info-display label="Vehicle" :value="!!vehicleObj ? vehicleObj.name : '-'"></row-info-display>
              <div class="grey lighten-2 mb-2" style="height: 1px; width:100%;"></div>

              <row-info-display label="Tip" :value="!!tipObj ? tipObj.name : '-'"></row-info-display>
              <div class="grey lighten-2 mb-2" style="height: 1px; width:100%;"></div>

              <row-info-display label="Spoil" :value="!!spoilObj ? spoilObj.name : '-'"></row-info-display>
            </div>
          </v-flex>

          <v-flex xs12 class="text-xs-center" v-if="loading">
            <v-progress-circular indeterminate :color="$store.state.global.pages.rate.color"></v-progress-circular>
          </v-flex>

          <template v-if="!!rate && canGetRate">
            <flex-sub-header>Standard Rate</flex-sub-header>
            <v-flex xs12 class="flex-container-space-between">
              <div v-if="!!userShowCost">Cost: {{editedRate.costPrice}} / {{editedRate.costUnit}}</div>
              <div v-if="!!userShowSell">Sell: {{editedRate.sellPrice}} / {{editedRate.sellUnit}}</div>
            </v-flex>
            <flex-sub-header>Alternate Rate</flex-sub-header>
            <v-flex xs12 class="flex-container-space-between">
              <div
                v-if="!!userShowCost"
              >Cost: {{editedRate.costPriceAlt}} / {{editedRate.costUnitAlt}}</div>
              <div
                v-if="!!userShowSell"
              >Sell: {{editedRate.sellPriceAlt}} / {{editedRate.sellUnitAlt}}</div>
            </v-flex>
            <flex-sub-header>Night Rate</flex-sub-header>
            <v-flex xs12 class="flex-container-space-between">
              <div
                v-if="!!userShowCost"
              >Cost: {{editedRate.costPriceNight}} / {{editedRate.costUnitNight}}</div>
              <div
                v-if="!!userShowSell"
              >Sell: {{editedRate.sellPriceNight}} / {{editedRate.sellUnitNight}}</div>
            </v-flex>
            <flex-sub-header>Sunday Rate</flex-sub-header>
            <v-flex xs12 class="flex-container-space-between">
              <div
                v-if="!!userShowCost"
              >Cost: {{editedRate.costPriceSunday}} / {{editedRate.costUnitSunday}}</div>
              <div
                v-if="!!userShowSell"
              >Sell: {{editedRate.sellPriceSunday}} / {{editedRate.sellUnitSunday}}</div>
            </v-flex>
            <flex-sub-header>Sunday Alt. Rate</flex-sub-header>
            <v-flex xs12 class="flex-container-space-between">
              <div
                v-if="!!userShowCost"
              >Cost: {{editedRate.costPriceAltSunday}} / {{editedRate.costUnitAlt}}</div>
              <div>Sell: {{editedRate.sellPriceAltSunday}} / {{editedRate.sellUnitAlt}}</div>
            </v-flex>
          </template>

          <template v-if="!canGetRate">
            <v-flex xs12 class="text-xs-center">
              <div class="grey--text body-2">Not enough selected data to find a rate for this trip.</div>
            </v-flex>
          </template>
        </v-layout>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="orange" @click="tripRate = null" v-if="!!tripRate">Clear Rate</v-btn>
        <div v-if="different && canGetRate">
          <v-btn color="grey darken-2" flat @click="discard()">Discard?</v-btn>
          <v-btn color="green" flat type="submit">Save</v-btn>
        </div>
        <div v-else>
          <v-btn color="grey darken-2" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import RateService from "@/services/requests/rateService";
import RowInfoDisplay from "@/components/ui/rowInfoDisplay";
export default {
  data() {
    return {
      loading: false,
      units: ["TONNE", "HOUR", "DAY", "EA"],
      editedRate: {}
    };
  },
  components: {
    RowInfoDisplay
  },
  methods: {
    close() {
      this.$emit("close");
    },
    discard() {
      this.editedRate = Object.assign({}, this.rate);
      this.close();
    },
    submitEditTripRateForm() {
      if (!this.$refs.editTripRateForm.validate()) {
        return;
      }
      this.save();
    },
    save() {
      //this.snack({text: 'Something will happen.', color: 'blue'})
      this.tripRate = this.editedRate;
      this.close();
      //save pricingObj in trip store, to become a part of trip when submitted.
    }
  },
  computed: {
    site: Store.getSet({ store: "dockets", prop: "site" }),
    vehicleId: Store.getSet({ store: "dockets", prop: "vehicleId" }),
    tip: Store.getSet({ store: "trips", prop: "tip" }),
    spoil: Store.getSet({ store: "trips", prop: "spoil" }),
    tripRate: Store.getSet({ store: "trips", prop: "tripRate" }),
    displayRate: Store.getSet({ store: "trips", prop: "displayRate" }),
    useNightRate: Store.getSet({ store: "trips", prop: "useNightRate" }),
    useAltRate: Store.getSet({ store: "trips", prop: "useAltRate" }),

    siteObj() {
      return this.getObjByPrimaryId(this.site, this.$store.state.sites.sites);
    },
    vehicleObj() {
      return this.getObjByPrimaryId(
        this.vehicleId,
        this.$store.state.vehicles.vehicles
      );
    },
    tipObj() {
      return this.getObjByPrimaryId(this.tip, this.$store.state.tips.tips);
    },
    spoilObj() {
      return this.getObjByPrimaryId(
        this.spoil,
        this.$store.state.spoils.spoils
      );
    },
    different() {
      if (!this._.isEqual(this.rate, this.editedRate)) {
        return true;
      } else {
        return false;
      }
    },
    canGetRate() {
      if (!this.site || !this.vehicleId || !this.tip || !this.spoil) {
        return false;
      }
      return true;
    }
  },

  asyncComputed: {
    rate() {
      if (!!this.tripRate) {
        this.editedRate = Object.assign({}, this.tripRate);
        return this.tripRate;
      }
      if (!this.site || !this.vehicleId || !this.tip || !this.spoil) {
        //return {}
        return null;
      }
      this.loading = true;
      var params = {
        siteId: this.site,
        vehicleId: this.vehicleId,
        tipId: this.tip,
        spoilId: this.spoil
      };
      return RateService.getRateByParams(params)
        .then(result => {
          this.loading = false;
          //console.log(result.data.result);
          if (!result.data.result.id) {
            this.snack({ text: "Pricing not found!", color: "yellow" });
          } else {
            this.snack({ text: "Retreived Rate", color: "green" });
          }

          this.editedRate = Object.assign({}, result.data.result);
          return result.data.result;
        })
        .catch(err => {
          this.loading = false;
          console.log(err.response.data);
          this.snack({ text: err.repsonse.data.message, color: "red" });
          return null;
        });
    }
  },
  watch: {
    rate(val) {
      this.displayRate = val;
    }
  }
};
</script>

<style>
</style>
